
































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Lazy, removeItemFromLocalStorage, StoregeKey } from '../utils';
import { LoginCredentials } from '../models';

@Component
export default class Login extends Vue {
    valid: boolean = false;
    stayConnected: boolean = false;
    name: string = '';
    password: string = '';
    nameRules = [v => !!v || 'El nombre es requerido'];
    passwordRules = [v => !!v || 'La contraseña es requerida'];
    @Prop({ default: () => () => console.log('[Login] updateStateError') })
    updateStateError: Lazy<void>;
    @Prop({ default: false }) isUserLogged: boolean;
    @Prop({ default: false }) stateError: boolean;
    @Prop({ default: false }) isLoading: boolean;

    get form(): HTMLFormElement {
        return this.$refs.form as HTMLFormElement;
    }

    @Emit()
    login(): LoginCredentials {
        return { username: this.name, password: this.password, remember_me: this.stayConnected };
    }

    submit() {
        this.updateStateError();
        if (this.form.validate()) {
            this.login();
        }
    }

    handleInput() {
        if (this.stateError) {
            this.updateStateError();
            removeItemFromLocalStorage(StoregeKey.USER_DEBT)
        }
    }
}
